import { render, staticRenderFns } from "./PublicLayout.vue?vue&type=template&id=824c6342"
import script from "./PublicLayout.vue?vue&type=script&lang=ts"
export * from "./PublicLayout.vue?vue&type=script&lang=ts"
import style0 from "./PublicLayout.vue?vue&type=style&index=0&id=824c6342&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
